import React, { Component } from 'react'
import DashboardLayout from '../layouts/DashboardLayout'
import CheckLoginStatus from '../conditions/CheckLoginStatus'
import Card from '../components/Card'
import Paragraph from '../components/Paragraph'
import Grid from '../components/Grid'
import styled from 'styled-components'

const PlaylistLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--${props => props.disabled ? 'gray' : props.color});
  color: #fff;
  padding: 0.75rem 1.25rem;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  transition: all 0.2s;
  font-weight: 300;
  border-radius: 1.25rem;
  width: 100%;
  text-decoration: none;
  text-align: center;
  &:hover {
    box-shadow: ${props => props.disabled ? 'none' : `0 0 5px var(--${props.color})`};
  }
`

export default class SIGHTVideoExamples extends Component {
  render() {
    return (
      <CheckLoginStatus loggedOutRedirect="/">
        <DashboardLayout title="SIGHT Video Examples" backHref="/resources" backText="Resources">
          <Card>
            <Card.Pad>
              <Paragraph str="Below are links to YouTube playlists of counselor training videos. Please use these videos to learn how patient counseling sessions may be conducted." />
            </Card.Pad>
          </Card>
          <Grid>
            <Grid.HalfCell>
              <PlaylistLink color="blue" href="https://www.youtube.com/playlist?list=PLEhRtVpQW9TV1pXuNBZocF_SHlLVe3Q2x" target="_blank">1. Full Sessions</PlaylistLink>
            </Grid.HalfCell>
            <Grid.HalfCell>
              <PlaylistLink color="blue" href="https://www.youtube.com/playlist?list=PLEhRtVpQW9TXqBj5hJYDLjzDxSrNMnI3c" target="_blank">2. Skills</PlaylistLink>
            </Grid.HalfCell>
          </Grid>
        </DashboardLayout>
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/SIGHTVideoExamples.js